// extracted by mini-css-extract-plugin
export default {"root":"ZS_FtHtC3C","root_disabled":"C9NUNFG5PA","appIconWrapper":"y2NU37x9Vf","appIconWrapper_colorizedSvg":"Wgw_fz6lDA","appIcon":"zilmjMtxJm","name":"HRz27sMehF"};